<template>
    <div>
        <div class="preview-opration">
            <el-select v-model="queryParams.recommendType" @change="searchRecommendPositionList" placeholder="推荐位位置">
                <el-option v-for="item in recommendTypeArr" :key="item.id" :label="item.label"
                           :value="item.value"></el-option>
            </el-select>
            <el-select :value="query.language" @change="handleQueryChange('language', $event)" placeholder="请选择">
                <el-option v-for="item in languageList" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
            </el-select>
            <el-button style="margin-left: 30px" icon="el-icon-plus" type="danger" @click="createDialog">新增
            </el-button>
        </div>
        <div class="recommend-position-list">
            <el-table class="recommend-position-table" border
                      :header-cell-style="{background:'#FFF5F4',color:'#EC6D56'}"
                      :data="recommendPositionList" :row-key="() => Math.random()">
                <el-table-column prop="imgageOder" label="序号" width="100px" show-overflow-tooltip></el-table-column>
                <el-table-column label="推荐图" width="100px">
                    <template slot-scope="scope">
                        <img style="width: 50px; height: 50px" :src="scope.row.imageUrl"/>
                    </template>
                </el-table-column>
                <el-table-column prop="recommendType" label="位置" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span>{{formatType(scope.row.recommendType)}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="recommendTitle" label="名称" show-overflow-tooltip></el-table-column>
                <el-table-column prop="synopsis" label="简介" show-overflow-tooltip></el-table-column>
                <el-table-column prop="linkUrl" label="内容地址" show-overflow-tooltip></el-table-column>
                <el-table-column label="开始时间" width="200px">
                    <template slot-scope="scope">
                        <span>{{scope.row.startTime | moment}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="结束时间" width="200px">
                    <template slot-scope="scope">
                        <span>{{scope.row.endTime | moment}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="创建时间" width="200px">
                    <template slot-scope="scope">
                        <span>{{scope.row.createTime | moment}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="状态" width="200px">
                    <template slot-scope="scope">
                        <span>{{scope.row.activated | formatState}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="300px">
                    <template slot-scope="scope">
                        <el-button type="primary" icon="el-icon-edit" @click="updateDialog(scope.row)">修改
                        </el-button>
                        <el-button v-if="scope.row.activated==0" type="danger" icon="el-icon-delete"
                                   @click="handleRemove(scope.row.id,'NO')">下架
                        </el-button>
                        <el-button v-if="scope.row.activated==1" type="danger" icon="el-icon-delete"
                                   @click="handleRemove(scope.row.id,'YES')">上架
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination style="margin-top: 30px"
                           @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           :current-page="queryParams.page"
                           :page-sizes="[10, 20, 50, 100]"
                           :page-size="queryParams.size"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="total">
            </el-pagination>
        </div>

        <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="50%" @close="clearData">
            <div>
                <div>
                    <span style="padding-right: 20px"><span style="color: red">*</span> 推荐位置</span>
                    <el-select v-model="recommendData.recommendType" placeholder="推荐位位置">
                        <el-option v-for="item in recommendTypeArrs" :key="item.id" :label="item.label"
                                   :value="item.value"></el-option>
                    </el-select>
                </div>
                <div style="margin-top: 20px">
                    <span style="padding-right: 20px"><span style="color: red">*</span> 序&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;号</span>
                    <el-input-number v-model="recommendData.imgageOder" :min="0" :max="10000000"
                                     style="width: 200px"></el-input-number>
                </div>
                <div style="margin-top: 20px">
                    <span style="padding-right: 20px"><span style="color: red">*</span> 名&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;称</span>
                    <el-input maxlength="50" v-model="recommendData.recommendTitle" style="width: 70%"></el-input>
                </div>
                <div style="margin-top: 20px">
                    <span style="padding-right: 20px"><span style="color: red">*</span> 简&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;介</span>
                    <el-input maxlength="50" type="textarea" :rows="5" v-model="recommendData.synopsis"
                              style="width: 70%"></el-input>
                </div>
                <div style="margin-top: 20px">
                    <span style="padding-right: 20px"><span style="color: red">*</span> 内容地址</span>
                    <el-input v-model="recommendData.linkUrl" style="width: 70%"></el-input>
                </div>
                <div style="margin-top: 20px">
                    <span style="padding-right: 20px"><span style="color: red">*</span> 推荐图</span>
                    <uploadMoulde style="margin-left: 15px;display: inline-block" :value="recommendData.imageUrl"
                                  :limitNumber="1"
                                  v-on:input="getSucessInfo" ref="childUpload"></uploadMoulde>
                </div>
                <div style="margin-top: 20px">
                    <span style="padding-right: 21px"><span style="color: red">*</span> 选择时间</span>
                    <el-date-picker v-model="dateArr" value-format="timestamp" type="datetimerange" range-separator="——"
                                    start-placeholder="开始日期" end-placeholder="结束日期">
                    </el-date-picker>
                </div>

            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="danger" @click="createRecommendPosition">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import '../store';
    import api from '../api';
    import {mapMutations, mapState} from 'vuex';
    import uploadMoulde from "../../../components/upload/indexLimit.vue";

    export default {
        name: 'RecommendPosition',
        components: {
            uploadMoulde
        },
        data() {
            return {
                recommendPositionList: [], //推荐位列表
                total: 0, //总条数
                queryParams: { //查询参数
                    lang: "",
                    recommendType: "",
                    page: 1,
                    size: 10
                },
                recommendData: { //数据
                    recommendId: -1,
                    recommendType: "NEWS_ITEM",
                    recommendTitle: "",
                    synopsis: "",
                    linkUrl: "",
                    imageUrl: "",
                    imgageOder: 0,
                    startTime: 0,
                    endTime: 0,
                    lang: ""
                },
                dialogVisible: false, //对话框是否显示
                dialogTitle: "",  //弹框标题
                currOpration: 0,  //当前操作 0-新增，1修改
                dateArr: [], //日期
                recommendTypeArr: [
                    {id: 1, label: "所有", value: ""}
                ],
                recommendTypeArrs: []
            };
        },
        computed: {
            ...mapState('cmsManage', ['languageList', 'query'])
        },
        filters: {
            formatState(state) {
                switch (state) {
                    case 0:
                        return "上架";
                    case 1:
                        return "下架";
                }
            }
        },
        methods: {
            ...mapMutations('cmsManage', ['changeQuery']),
            handleQueryChange(type, value) {
                this.changeQuery({
                    ...this.query,
                    [type]: value
                });
                this.queryParams.page = 1;
                this.queryParams.lang = value;
                this.getRecommendPositionList(this.queryParams);
            },
            formatType(type) {
                let value = this.recommendTypeArrs.find(x => x.value == type);
                if (value) {
                    return value.label;
                }
                return "";
            },
            searchRecommendPositionList() {
                this.queryParams.page = 1;
                this.getRecommendPositionList(this.queryParams);
            },
            getRecommendPositionList(query) {
                api.getRecommendPositionList(query).then(({data}) => {
                    this.recommendPositionList = data.records;
                    this.total = data.total;
                });
            },
            getRecommendPositionTypes() {
                api.getRecommendPositionTypes().then(({data}) => {
                    this.recommendTypeArrs = data;
                    this.recommendTypeArr = this.recommendTypeArr.concat(data);
                });
            },
            handleSizeChange(val) {
                this.queryParams.size = val;
                this.getRecommendPositionList(this.queryParams);
            },
            handleCurrentChange(val) {
                this.queryParams.page = val;
                this.getRecommendPositionList(this.queryParams);
            },
            getSucessInfo(data) {
                //上传成功
                this.recommendData.imageUrl = data;
            },
            createDialog() {
                this.currOpration = 0;
                this.dialogTitle = "新增推荐位";
                this.dialogVisible = true;
            },
            updateDialog(row) {
                this.currOpration = 1;
                this.dialogTitle = "修改推荐位";
                this.recommendData.recommendId = row.id;
                this.recommendData.recommendType = row.recommendType;
                this.recommendData.recommendTitle = row.recommendTitle;
                this.recommendData.synopsis = row.synopsis;
                this.recommendData.linkUrl = row.linkUrl;
                this.recommendData.imageUrl = row.imageUrl;
                this.recommendData.imgageOder = row.imgageOder;
                this.recommendData.startTime = row.startTime;
                this.recommendData.endTime = row.endTime;
                this.recommendData.lang = row.language;
                this.dateArr = [row.startTime, row.endTime];
                this.dialogVisible = true;
            },
            createRecommendPosition() {
                if (this.recommendData.imgageOder == "") {
                    this.$message.success('序号不能为空！');
                    return;
                }
                if (this.recommendData.recommendType == "") {
                    this.$message.success('推荐位置不能为空！');
                    return;
                }
                if (this.recommendData.recommendTitle == "") {
                    this.$message.success('名称不能为空！');
                    return;
                }
                if (this.recommendData.synopsis == "") {
                    this.$message.success('简介不能为空！');
                    return;
                }
                if (this.recommendData.linkUrl == "") {
                    this.$message.success('内容地址不能为空！');
                    return;
                }
                if (this.recommendData.imageUrl == "") {
                    this.$message.success('请上传推荐图！');
                    return;
                }
                if (this.dateArr == null) {
                    this.$message.success('请选择时间！');
                    return;
                }
                this.recommendData.startTime = this.dateArr[0];
                this.recommendData.endTime = this.dateArr[1];
                this.recommendData.lang = this.query.language;
                if (this.currOpration == 1) {
                    api.updateRecommendPosition(this.recommendData).then(({data}) => {
                        this.dialogVisible = false;
                        this.queryParams.lang = this.query.language;
                        this.getRecommendPositionList(this.queryParams);
                    });
                } else {
                    api.addRecommendPosition(this.recommendData).then(({data}) => {
                        this.dialogVisible = false;
                        this.queryParams.lang = this.query.language;
                        this.getRecommendPositionList(this.queryParams);
                    });
                }
            },
            handleRemove(id, status) {
                this.$confirm('确认此操作吗？', '提示', {
                    type: 'warning'
                }).then(() => {
                    api.deleteRecommendPosition({"recommendId": id, "status": status}).then(({data}) => {
                        this.$message.success('操作成功！');
                        this.queryParams.lang = this.query.language;
                        this.getRecommendPositionList(this.queryParams);
                    });
                }).catch(() => {
                });
            },
            clearData() {
                this.$refs.childUpload.handleRemove();
                this.recommendData = { //数据
                    recommendId: -1,
                    recommendType: "NEWS_ITEM",
                    recommendTitle: "",
                    synopsis: "",
                    linkUrl: "",
                    imageUrl: "",
                    imgageOder: 0,
                    startTime: 0,
                    endTime: 0,
                    lang: ""
                }
                this.dateArr = null;
            }
        },
        created() {
            this.queryParams.lang = this.query.language;
            this.getRecommendPositionTypes();
            this.getRecommendPositionList(this.queryParams);
        }
    };
</script>

<style lang="less" scoped>
    .preview-opration {
        float: right;
    }

    .recommend-position-list {
        border: 1px solid #f2ece2;
        clear: both;
        width: 100%;
        .recommend-position-table {
            margin-top: 30px;
        }
    }
</style>